<template>
  <div class="feedback-comment">
    <div class="feedback-comment__header">
      <div class="feedback-comment__icon">
        <img :src="CommentIcon" alt="Comment" />
      </div>
      <h4 class="feedback-comment__title">Kommentar</h4>
    </div>
    <p class="feedback-comment__text">{{ comment }}</p>
  </div>
</template>

<script setup lang="ts">
import CommentIcon from "@/assets/img/comment.svg";

defineProps<{
  comment: string;
}>();
</script>

<style lang="scss" scoped>
.feedback-comment {
  background: #f7f0fa;
  border-radius: 8px;
  padding: 16px;

  &__header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
  }

  &__icon {
    width: 32px;
    height: 32px;
  }

  &__title {
    color: #1d1d1d;
    font-size: 14px;
    font-weight: 600;
  }

  &__text {
    background: white;
    border-radius: 8px;
    padding: 16px;
    color: #1d1d1d;
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
